export const invoicePdf = ({ invoice_id, odooSid}) => {
    const body = {
        'invoice_id':invoice_id,
    }
    return fetch("/api/invoice_pdf", {
        method: "POST",
        headers: {"content-type": "application/json","odoo": odooSid},
        body: JSON.stringify(body)
      }).then(res => {
        if (!res.ok) {
          throw new Error('Response is NOT ok');
        }
        return res.json();
      }).then(data => {
        if(data.error){
          throw new Error(data.error);
        }else
          return data.result;
      })

};